import classes from './FavoritesCard.module.scss';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setCarDetail } from '../../../../store/reducers/carReducer';

const FavoritesCard = ({content}) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    let vehicleName = `${content.model} ${content.makerDetail.maker} ${content.makerDetail.model} ${content.makerDetail.type}`;
    const onCardClickHandler = (content) => {
        const contentWithFavorite = {
            ...content,
            isFavorite: true
        };
        
        dispatch(setCarDetail(contentWithFavorite));
        window.open(`/detail/${content._id}`, '_blank');
    };
    return (
        <div className={classes.FavoritesCard} onClick={() => onCardClickHandler(content)}>
            <div className={classes.ImgContainer}>
                <img src={content.vehicleImages[0]} alt={content.vehicleName} />
                <div className={classes.Km}>
                    <p>● {content.mileage}</p>
                </div>
                <div className={classes.Bid}>
                    <p>Bid No: {content.bidNo.replace(/^No\./, '')}</p>
                </div>
            </div>
            <div className={classes.TextContainer}>
                <h5>{vehicleName}</h5>
                <div className={classes.Info}>
                    <div className={classes.InfoContext}>
                        <div className={classes.InfoIconContainer}>
                            <i className="far fa-star"></i>
                        </div>
                        <p>Grade: {content.inspectionScore}</p>
                    </div>
                    <div className={classes.InfoContext}>
                        <div className={classes.InfoIconContainer}>
                        <i className="fas fa-gavel"></i>
                        </div>
                        <p>{content.bidDetail?.bidSite}</p>
                    </div>
                    <div className={classes.InfoContext}>
                        <div className={classes.InfoIconContainer}>
                        <i className="far fa-calendar"></i>
                        </div>
                        <p>{content.bidDetail?.bidDate}</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default FavoritesCard;